import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_STYLES = 'SET_STYLES';

const setStyles = payload => ({ type: SET_STYLES, payload });

export const setStylesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.STYLES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var stylesSnap = snapshot.val();
                    var styles = [];
                    stylesSnap.forEach(style => {
                        styles.push(style);
                    });
                    dispatch(setStyles(styles));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setStyles([]));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setStyles([]));
        });
    };
};